import { render, staticRenderFns } from "./EmployeeIdentifyInfo.vue?vue&type=template&id=6a9d6508&scoped=true&"
import script from "./EmployeeIdentifyInfo.vue?vue&type=script&lang=js&"
export * from "./EmployeeIdentifyInfo.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeIdentifyInfo.vue?vue&type=style&index=0&id=6a9d6508&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9d6508",
  null
  
)

export default component.exports